module.exports = __webpack_public_path__ + "static/element-2a8cb0983c61f700ca5ac3816b30b8a8.png";